"use client";

import useTranslationApi from "@/lib/hooks/useTranslationApi";

export default function ProductStatus({
	isOutOfStock,
}: {
	isOutOfStock: boolean;
}) {
	const { t } = useTranslationApi([
		"product_out_of_stock",
		"product_not_out_of_stock",
	]);

	return (
		<>
			{isOutOfStock ? (
				<span className=" text-red-500  font-semibold uppercase   text-base">
					{t("product_out_of_stock")}
				</span>
			) : (
				<span className=" text-blue-main  font-semibold  uppercase text-base">
					{t("product_not_out_of_stock")}
				</span>
			)}
		</>
	);
}
